import React from 'react';
import { Copy, Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
const EmptyCustomizationSummarySectionList = ({ dataTestId }) => {
    const { t } = useTranslation();
    return (React.createElement(Box, { style: { padding: '8px 16px' } },
        React.createElement(Copy, { size: "regular", "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'cy-customization-summary-empty-section-list' }, t('Pages.Bap.noAdditionaItemsAddedText'))));
};
export default EmptyCustomizationSummarySectionList;
